import LoginAlternatives from "components/login/LoginAlternatives";
import LoginForm from "components/login/LoginForm";
import WelcomeBack from "components/login/WelcomeBack";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useUserContext } from "api/user/UserProvider";
import { LOGIN_ALTERNATIVES } from "constants/constants";

const isLocalDev = () => process.env.NODE_ENV === "development";

const Login = () => {
  const {
    userLogin,
    response,
    showLoginFallbackHint,
  } = useUserContext();
  const [loginALternative, setLoginALternative] = useState(
    isLocalDev() ? undefined : LOGIN_ALTERNATIVES.SSO
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    await userLogin(e.target["username"].value, e.target["password"].value);
  };

  const handleRequestFallback = () => {
    setLoginALternative(LOGIN_ALTERNATIVES.NORMAL);
  };

  useEffect(() => {
    if (showLoginFallbackHint) {
      setLoginALternative(LOGIN_ALTERNATIVES.NORMAL);
    }
  }, [showLoginFallbackHint]);

  return (
    <div className="login">
      <div className="login-top">
        <div className="login-box">
          <WelcomeBack />
          {showLoginFallbackHint && (
            <div className="login-fallback-hint-message">
              <p>
                <FormattedMessage
                  id={"login_fallback_hint_line1"}
                  defaultMessage={
                    "Oh non, nous n'avons pas réussi à te reconnaître !"
                  }
                />
              </p>
              <p>
                <FormattedMessage
                  id={"login_fallback_hint_line2"}
                  defaultMessage={
                    "Pas de panique, reconnecte-toi directement avec tes identifiants Portal ci-dessous."
                  }
                />
              </p>
            </div>
          )}
          {loginALternative === LOGIN_ALTERNATIVES.NORMAL ? (
            <LoginForm handleSubmit={handleSubmit} response={response} />
          ) : (
            <LoginAlternatives
              onRequestNormal={handleRequestFallback}
              showNormalButton={isLocalDev()}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
